<div class="container h-100" *ngIf="isLoading == true" [dir]="globalService.isRTL == true ? 'RTL' : 'LTR'">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
</div>
<span [lang]="language" [dir]="globalService.isRTL == true ? 'RTL' : 'LTR'" *ngIf="isLoading == false">
  <div class="header" *ngIf="globalService.serviceNotFound == false" [@.disabled]="disableAnimation">
      <app-member-navigation ></app-member-navigation>
  </div>

  <div class="content">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</span> 